import { ApiResponseNHL, useFetchLeagueData } from '~/core/api';

import { Standings, StandingsSeason } from './types';

export const useStandingsQuery = (date?: string): ApiResponseNHL<Standings> =>
    useFetchLeagueData(`/standings/${date || 'now'}`);

export const useSeasonsQuery = (): ApiResponseNHL<{ seasons: Array<StandingsSeason> }> =>
    useFetchLeagueData(`/standings-season`);
